import DOMPurify from 'dompurify';

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'b',
      'i',
      'em',
      'strong',
      'a',
      'ul',
      'ol',
      'li',
      'br',
      'blockquote',
      'span',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'data-user-id'],
  });
}

export function validateUrl(url: string): boolean {
  try {
    /* eslint-disable-next-line no-new */
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

export function setAutofocus($root: Element | null) {
  if (!$root) return;
  const $autofocus = $root.querySelectorAll('[autofocus]')[0];
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!$autofocus) return;
  const $active = document.activeElement;
  // @ts-expect-error
  if ($active.blur) $active.blur();
  // @ts-expect-error
  if ($autofocus.focus) $autofocus.focus();
}

export function setDelayedAutofocus($root: Element | null) {
  if (!$root) return;
  const $autofocus = $root.querySelectorAll('[autofocus]')[0];
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!$autofocus) return;
  setTimeout(function () {
    const $active = document.activeElement;
    if ($active === $autofocus) return;
    // @ts-expect-error
    if ($active.blur) $active.blur();
    setTimeout(function () {
      // @ts-expect-error
      if ($autofocus.focus) $autofocus.focus();
    }, 0);
  }, 100); // HACK popovers and "Autofocus processing was blocked because a document already has a focused element."
}
